import {Matcher} from '@/lib/axiosAddTransforms'
import {dateResponse} from '../utils'
import {DateTime} from 'luxon'
import {bizResponse} from '@/transformers/matchers/biz'

const matchers: Matcher[] = [
  {
    test: /^\/kakao\/(refresh-token|token)\/?$/,
    method: 'post',
    transform: {
      request: (payload) => {
        payload.baseURL = process.env.VUE_APP_API_KAKAO_URL
        payload.url = '/oauth/token'
        delete payload.headers
        payload.headers = {
          'Content-type': 'application/x-www-form-urlencoded;charset=utf-8',
        }
        payload.params = payload.data
        delete payload.data
        return payload
      },
      response: (data) => {
        if(!data) {
          return data
        }
        const {accessToken, expiresIn, refreshToken} = data
        if(!accessToken || !expiresIn) {
          return  data
        }
        const toDay = DateTime.local()
        const newData: any = {}
        newData.kakaoToken = accessToken
        newData.expiredAt = toDay.plus({seconds: expiresIn}).toMillis()
        if(refreshToken) {
          newData.kakaoRefreshToken = refreshToken
          newData.refreshExpiredAt = toDay.plus({months: 2}).toMillis()
        }
        return newData
      },
    },
  },
  {
    test: /^\/connect\/kakao\/?$/,
    method: 'post',
    transform: {
      request: (payload) => {
        if(!payload.data) {
          throw new Error('[transforms auth request] need data in your request')
        }
        payload.url = '/users/connect/kakao'
        delete payload.headers.Authorization
        const {kakaoToken} = payload.data
        delete payload.data.kakaoToken
        payload.data.accessToken = kakaoToken
        return payload
      },
      response: (data) => {
        if(!data || !data.user) {
          return data
        }
        if(data.isMatchtokenValid !== undefined) {
          localStorage.setItem('isMatchTokenValid', data.isMatchtokenValid)
        }

        return {
          accessToken: data.token,
          ...usersResponse(data.user),
        }
      },
    },
  },
  {
    test: /^\/users\/\$id\/?$/,
    method: 'get',
    transform: {
      request: (payload) => {
        payload.url = '/users/profile'
        return payload
      },
      response: (data) => {
        if(!data || !data.id) {
          return data
        }
        return usersResponse(data)
      },
    },
  },
  {
    test: /^\/users\/\$id\/?$/,
    method: 'patch',
    transform: {
      request: (payload) => {
        const {data} = payload
        if(!data) {
          return payload
        }
        payload.url = '/users/profile'
        payload.data = usersRequest(data)
        return payload
      },
      response: (data) => {
        if(!data || !data.id) {
          return data
        }
        return usersResponse(data)
      },
    },
  },
  {
    test: /^\/auth\/request-phone-code\/?$/,
    method: 'post',
    transform: {
      request: (payload) => {
        payload.url = '/auth/sms-request'
        return payload
      },
    },
  },
  {
    test: /^\/auth\/resister-phone\/?$/,
    method: 'patch',
    transform: {
      request: (payload) => {
        payload.url = '/users/profile/mobile-phone-number'
        const {phone, phoneCode} = payload.data
        payload.data = {
          mobilePhoneNumber: phone,
          certNumber: phoneCode,
        }
        return payload
      },
      response: (data) => {
        if(!data || !data.mobilePhoneNumber) {
          return data
        }
        return {
          phone: data.mobilePhoneNumber,
          isPhone: Boolean(data.mobilePhoneNumber),
        }
      },
    },
  },
]

const usersResponse = (data) => {
  const {
    id,
    name,
    username,
    mobilePhoneNumber,
    email,
    lastLogin,
    createdAt,
    modifiedAt,
    bizs = [],
  } = data
  return {
    id: String(id),
    identifier: username,
    name,
    isPhone: Boolean(mobilePhoneNumber),
    phone: mobilePhoneNumber,
    email,
    lastLogin: dateResponse(lastLogin),
    createdAt: dateResponse(createdAt),
    modifiedAt: dateResponse(modifiedAt),
    bizs: bizs.map((biz) => bizResponse(biz)),
  }
}

const usersRequest = (data) => {
  const {name, phone, email} = data
  return {
    name,
    mobilePhoneNumber: phone,
    email,
  }
}

export default matchers
